import React from "react";
import Container from "react-bootstrap/Container";
import {Row, Col, Stack, Card, Carousel} from "react-bootstrap";

import styles from './Footer.module.css'
import Image from '../../assets/images/logo.svg'


const Footer = () => {
    return (
        <div className={styles.my_footer}>
            <Container>
                <Row>
                    <Col md={2}>
                        <img src={Image}/>
                    </Col>
                    <Col md={8}></Col>
                    <Col md={2}>
                        <span>

                        </span>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Footer;